"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusError = exports.UserScope = void 0;
var UserScope;
(function (UserScope) {
    UserScope["PROPERTIES"] = "props";
    UserScope["PERMISSIONS"] = "permissions";
})(UserScope = exports.UserScope || (exports.UserScope = {}));
/**
 * To store the OAuth client's data between websites due to redirection.
 */
var LOCALSTORAGE_ID = "@adtech-web/twork-login-provider";
var StatusError = /** @class */ (function (_super) {
    __extends(StatusError, _super);
    function StatusError(message, status) {
        if (message === void 0) { message = ''; }
        var _this = _super.call(this, message) || this;
        _this.status = status;
        Object.setPrototypeOf(_this, StatusError.prototype);
        return _this;
    }
    return StatusError;
}(Error));
exports.StatusError = StatusError;
var TworkLoginProvider = /** @class */ (function () {
    function TworkLoginProvider(config) {
        this.state = {};
        var clientId = config.clientId, originUrl = config.originUrl;
        this.localStorageKey = "".concat(LOCALSTORAGE_ID, "/").concat(clientId);
        var authorizationUrl = config.authorizationUrl, tokenUrl = config.tokenUrl, jwksURL = config.jwksURL;
        if (!authorizationUrl)
            authorizationUrl = '/auth/connect/authorize';
        if (!tokenUrl)
            tokenUrl = '/auth/connect/token';
        if (!jwksURL)
            jwksURL = '/auth/.well-known/openid-configuration/jwks';
        this.config = __assign(__assign({}, config), { authorizationUrl: new URL(authorizationUrl, originUrl).toString(), tokenUrl: new URL(tokenUrl, originUrl).toString(), jwksURL: new URL(jwksURL, originUrl).toString() });
        this.recoverState();
    }
    /**
     * If there is an error, it will be passed back as a rejected Promise.
     * If there is no code, the user should be redirected via
     * [fetchAuthorizationCode].
     */
    TworkLoginProvider.prototype.isReturningFromAuthServer = function () {
        var error = TworkLoginProvider.extractParamFromUrl(location.href, 'error');
        if (error) {
            return Promise.reject(error);
        }
        var code = TworkLoginProvider.extractParamFromUrl(location.href, 'code');
        if (!code) {
            return Promise.resolve(false);
        }
        this.setState(__assign(__assign({}, this.state), { authorizationCode: code, hasAuthCodeBeenExchangedForAccessToken: false }));
        var urlWithoutQueryParams = TworkLoginProvider.removeQueryParams(location.href);
        window.history.replaceState({}, '', urlWithoutQueryParams);
        return Promise.resolve(true);
    };
    /**
     * Fetch an authorization grant via redirection. In a sense this function
     * doesn't return because of the redirect behavior (uses `location.replace`).
     */
    TworkLoginProvider.prototype.fetchAuthorizationCode = function () {
        var _a = this.config, clientId = _a.clientId, redirectUrl = _a.redirectUrl, scopes = _a.scopes;
        var nonce = this.generateRandomNonce(8);
        this.setState(__assign(__assign({}, this.state), { nonce: nonce }));
        var url = this.config.authorizationUrl +
            "?response_type=code&response_mode=query&" +
            "client_id=".concat(encodeURIComponent(clientId), "&") +
            "redirect_uri=".concat(encodeURIComponent(redirectUrl), "&") +
            "scope=".concat(encodeURIComponent(scopes.join(' ')), "&") +
            "nonce=".concat(encodeURIComponent(nonce));
        location.replace(url);
    };
    /**
     * Tries to get the current access token. If there is none
     * it will fetch another one.
     */
    TworkLoginProvider.prototype.getAccessToken = function () {
        var _a = this.state, accessToken = _a.accessToken, authorizationCode = _a.authorizationCode, hasAuthCodeBeenExchangedForAccessToken = _a.hasAuthCodeBeenExchangedForAccessToken, scopes = _a.scopes;
        if (this.authCodeForAccessTokenRequest) {
            return this.authCodeForAccessTokenRequest;
        }
        if (!this.isAuthorized() || !hasAuthCodeBeenExchangedForAccessToken) {
            if (!authorizationCode)
                return Promise.reject(new Error('No authorization code'));
            this.authCodeForAccessTokenRequest =
                this.exchangeAuthCodeForAccessToken();
            return this.authCodeForAccessTokenRequest;
        }
        return Promise.resolve({ token: accessToken, scopes: scopes });
    };
    TworkLoginProvider.prototype.fetchUser = function (config) {
        var _a = this.config, jwtProvider = _a.jwtProvider, jwksURL = _a.jwksURL;
        return this.getAccessToken()
            .then(function (_a) {
            var token = _a.token;
            if (!token)
                throw new Error('Access token not found');
            return jwtProvider.jwtVerify(token.value, new URL(jwksURL));
        })
            .then(function (_a) {
            var family_name = _a.family_name, given_name = _a.given_name, user_id = _a.user_id;
            return { id: user_id, first_name: given_name, last_name: family_name };
        });
    };
    /**
     * Tells if the client is authorized or not. This means the client has at
     * least once successfully fetched an access token. The access token could be
     * expired.
     */
    TworkLoginProvider.prototype.isAuthorized = function () {
        return !!this.state.accessToken;
    };
    TworkLoginProvider.prototype.reset = function () {
        this.setState({});
        this.authCodeForAccessTokenRequest = undefined;
    };
    TworkLoginProvider.prototype.getReferer = function () {
        return undefined;
    };
    /**
     * Fetch an access token from the remote service. You may pass a custom
     * authorization grant code for any reason, but this is non-standard usage.
     */
    TworkLoginProvider.prototype.exchangeAuthCodeForAccessToken = function (codeOverride) {
        var _this = this;
        var _a = this.state.authorizationCode, authorizationCode = _a === void 0 ? codeOverride : _a;
        var _b = this.config, clientId = _b.clientId, redirectUrl = _b.redirectUrl;
        var url = this.config.tokenUrl;
        var body = "grant_type=authorization_code&" +
            "code=".concat(encodeURIComponent(authorizationCode || ''), "&") +
            "redirect_uri=".concat(encodeURIComponent(redirectUrl), "&") +
            "client_id=".concat(encodeURIComponent(clientId), "&");
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
            .then(function (res) {
            if (res.ok)
                return res.json();
            return res
                .json()
                .catch(function () { return ({ error: 'invalid_json' }); })
                .then(function (_a) {
                var error = _a.error;
                throw new StatusError(error, res.status);
            });
        })
            .then(function (_a) {
            var access_token = _a.access_token, expires_in = _a.expires_in, scope = _a.scope;
            _this.state.hasAuthCodeBeenExchangedForAccessToken = true;
            _this.authCodeForAccessTokenRequest = undefined;
            return _this.setAccessToken({ access_token: access_token, expires_in: expires_in, scope: scope });
        });
    };
    TworkLoginProvider.prototype.setAccessToken = function (_a) {
        var access_token = _a.access_token, expires_in = _a.expires_in, scope = _a.scope;
        var accessToken = {
            value: access_token,
            expiry: new Date(Date.now() + +expires_in * 1000).toString(),
        };
        var scopes = scope ? scope.split(' ') : [];
        this.setState(__assign(__assign({}, this.state), { accessToken: accessToken, scopes: scopes }));
        return { token: accessToken, scopes: scopes };
    };
    TworkLoginProvider.prototype.setState = function (state) {
        this.state = state;
        localStorage.setItem(this.localStorageKey, JSON.stringify(state));
    };
    TworkLoginProvider.prototype.recoverState = function () {
        this.state = JSON.parse(localStorage.getItem(this.localStorageKey) || '{}');
    };
    /**
     * Extracts a query string parameter.
     */
    TworkLoginProvider.extractParamFromUrl = function (url, param) {
        var queryString = url.split('?');
        if (queryString.length < 2) {
            return '';
        }
        queryString = queryString[1].split('#');
        var parts = queryString[0]
            .split('&')
            .reduce(function (a, s) { return a.concat(s.split('=')); }, []);
        if (parts.length < 2) {
            return '';
        }
        var paramIdx = parts.indexOf(param);
        return decodeURIComponent(paramIdx >= 0 ? parts[paramIdx + 1] : '');
    };
    /**
     * Removes the query string parameters to clean up the URL.
     */
    TworkLoginProvider.removeQueryParams = function (url) {
        var _a = url.split('?'), urlPart = _a[0], queryStringAndHashUrlPart = _a[1];
        var _b = queryStringAndHashUrlPart.split('#'), hashUrlPart = _b[1];
        return "".concat(urlPart).concat(hashUrlPart !== undefined ? "#".concat(hashUrlPart) : '');
    };
    TworkLoginProvider.prototype.generateRandomNonce = function (lengthOfNonce) {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        var result = '';
        var counter = 0;
        while (counter < lengthOfNonce) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    };
    return TworkLoginProvider;
}());
exports.default = TworkLoginProvider;
